import { render, staticRenderFns } from "./PersonGroupSelector.vue?vue&type=template&id=09d9c296"
import script from "./PersonGroupSelector.vue?vue&type=script&lang=js"
export * from "./PersonGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./PersonGroupSelector.vue?vue&type=style&index=0&id=09d9c296&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports